import { action, makeObservable, observable } from 'mobx';
import { RoundStatus } from '../../../core/constants/roundStatus';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { crashCountdownDeductionValues } from '../crashCore/constants';

class GameStore {
  timeData = {
    timerValue: null,
    ...crashCountdownDeductionValues,
  };

  oddData = null;

  roundId = null;

  timerDuration = 6;

  isSlowConnection = false;

  wonOdd = 0;

  ratingStarsCountWithText = {
    count: 0,
    text: '',
  };

  isPongReceived = false;

  roundFinishedData = {
    finishedOdd: null,
    currentUserData: null,
    finishedOddStatus: '',
  };

  gameLatestResults = [];

  currentRoundStatus = null;

  constructor() {
    makeObservable(this, {
      timeData: observable.deep,
      roundId: observable,
      oddData: observable,
      timerDuration: observable,
      wonOdd: observable,
      isPongReceived: observable,
      isSlowConnection: observable,
      ratingStarsCountWithText: observable.deep,
      currentRoundStatus: observable,
      roundFinishedData: observable.deep,
      gameLatestResults: observable.deep,
      setTimeData: action.bound,
      setRoundId: action.bound,
      setOddData: action.bound,
      setRoundFinishedData: action.bound,
      resetRoundFinishedData: action.bound,
      setTimerDuration: action.bound,
      setIsPongReceived: action.bound,
      setWonBetOdd: action.bound,
      updateSlowConnection: action.bound,
      setGameLatestResults: action.bound,
      resetRatingStarsCountWithText: action.bound,
      updateCurrentRoundStatus: action.bound,
      decideRatingStarsCount: action.bound,
    });
  }

  setTimeData(time) {
    this.timeData = {
      ...this.timeData,
      timerValue: time,
    };
  }

  updateCurrentRoundStatus(currentRoundStatus) {
    this.currentRoundStatus = currentRoundStatus;
  }

  updateRatingStarsCount(currentRatingStarsCount, text) {
    this.ratingStarsCountWithText = {
      count: currentRatingStarsCount,
      text,
    };
  }

  resetRatingStarsCountWithText() {
    this.ratingStarsCountWithText = {
      count: 0,
      text: '',
    };
  }

  setWonBetOdd(odd) {
    this.wonOdd = odd;
  }

  updateSlowConnection(isSlowConnection) {
    this.isSlowConnection = isSlowConnection;
  }

  setRoundId(roundId) {
    this.roundId = roundId;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  showOdd = () => {
    const { finishedOdd } = this.roundFinishedData;

    if (finishedOdd) {
      return `x${finishedOdd}`;
    }
    if (this.oddData) {
      return `x${(Math.trunc(this.oddData * 100) / 100).toFixed(2)}`;
    }
    return '';
  };

  setOddData(odd) {
    this.oddData = odd;
  }

  decideRatingStarsCount(odd) {
    if (odd) {
      if (odd > 100 && odd < 110) {
        this.updateRatingStarsCount(3, TranslationKeys.Sensational);
      } else if (odd > 30 && odd < 34) {
        this.updateRatingStarsCount(2, TranslationKeys.Epic);
      } else if (odd > 10 && odd < 12) {
        this.updateRatingStarsCount(1, TranslationKeys.Nice);
      } else {
        this.updateRatingStarsCount(0, '');
      }
    }
  }

  setRoundFinishedData(roundFinishedData) {
    this.roundFinishedData = roundFinishedData;
  }

  resetRoundFinishedData() {
    this.roundFinishedData = { finishedOdd: null, finishedOddStatus: '', currentUserData: null };
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  updateLatestResults(lastResult) {
    lastResult.wonOdd = this.wonOdd;
    const newResults = this.gameLatestResults;
    this.gameLatestResults.shift();
    setTimeout(() => {
      this.gameLatestResults = [...newResults, lastResult];
    }, 25);
    this.setWonBetOdd(0);
  }

  setGameLatestResults(gameLatestResults) {
    this.gameLatestResults = gameLatestResults
      .filter((item) => item.status === RoundStatus.finished)
      .slice(0, 5)
      .reverse();
  }

  resetStore() {
    this.timeData = {
      timerValue: null,
      ...crashCountdownDeductionValues,
    };
    this.oddData = null;
    this.roundId = '';
    this.timerDuration = 6;
    this.isSlowConnection = false;
    this.wonOdd = 0;
    this.ratingStarsCountWithText = {
      count: 0,
      text: '',
    };
    this.isPongReceived = false;
    this.roundFinishedData = {
      finishedOdd: null,
      currentUserData: null,
      finishedOddStatus: '',
    };
    this.gameLatestResults = [];
    this.currentRoundStatus = null;
  }
}

export const crashGameStore = new GameStore();
